import React, { useState } from "react"
import { TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))

type StandardEmailFilter = Readonly<{
    value?: string
    onChange: (value?: string) => void
    type: "employeeId" | "orderId"
}>

export function StandardIdFilter({ value, onChange, type }: StandardEmailFilter) {
    const { l10n } = useAppLocalization()
    const { classes } = useStyles()

    const [error, setError] = useState<string | null>(null)

    const validateOnlyNumbers = (value: string) => {
        if (value === "") {
            return null // No error if the input is empty
        }
        if (!/^\d*$/.test(value)) {
            return l10n.getString("standard-id-filter-only-numbers-error-message")
        }
        return null
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        onChange(value)
        const validationError = validateOnlyNumbers(value)
        setError(validationError)
    }

    return (
        <LocalizedStrict
            id={type === "employeeId" ? "standard-id-filter-employee-id-label" : "standard-id-filter-order-id-label"}
            attrs={{ label: true }}
        >
            <TextField
                className={classes.input}
                error={!!error}
                helperText={error}
                name={type}
                value={value}
                onChange={handleChange}
            />
        </LocalizedStrict>
    )
}
